import {useState} from "react";
import {useAsyncFn, useEffectOnce} from "react-use";
import {bannerService} from "./BannerService";
import {AnalyticsEvents, postHogService} from "../../api/PostHogService";
import {IconButton} from "@atlaskit/button/new";
import CrossIcon from "@atlaskit/icon/glyph/cross";
import "./styles/ReviewBanner.scss";

const DISPLAY_START_DATE = "2024-11-21";
const DISPLAY_END_DATE = "2024-12-15";

export const ReviewBanner = ({isEnabled = true}: { isEnabled?: boolean }) => {
    const [showReviewBanner, setShowReviewBanner] = useState(false);
    AP.sizeToParent(true);

    useEffectOnce(() => {
        initBannerDisplay();
    });

    const initBannerDisplay = async () => {
        const currentDate = new Date();
        if (currentDate >= new Date(DISPLAY_START_DATE) && currentDate <= new Date(DISPLAY_END_DATE)) {
            fetchShouldBannerBeDisplayed();
        }
    }

    const [, fetchShouldBannerBeDisplayed] = useAsyncFn(async () => {
        const shouldDisplay = await bannerService.shouldDisplayReviewBanner();
        setShowReviewBanner(shouldDisplay);
    }, []);

    const [, onClickHideReviewBanner] = useAsyncFn(async () => {
        postHogService.logEvent(AnalyticsEvents.ADMIN_REVIEW_BANNER_HIDE_CLICKED);
        bannerService.hideReviewBanner();
        setShowReviewBanner(false);
    }, []);

    if (!showReviewBanner) {
        return null;
    }

    return (
        <>
            {isEnabled && showReviewBanner &&
                <div className={"review-banner-container"}>
                    <div style={{background: "center no-repeat url('/atl-assets/amp-background.png')"}} className={"review-banner"}>
                        <div className={"review-content"}>
                            <p className={"greetings-title"}>Spread Christmas Cheer!</p>
                            <p>Write a review for the App Navigation Menus in the Atlassian Marketplace and </p>
                            <h1>get a $50 gift card</h1>
                            <p className={"subtle"}>Redeemable at 100+ retailers on <a href={"https://www.tremendous.com/products/gift-cards/"}
                                                                                       target={"_blank"}>Tremendous</a> tailored to your Country.</p>
                            <div className={"buttons-container"}>
                                <a href={"https://marketplace.atlassian.com/apps/1227715/navigation-menus-for-confluence-quick-easy-orientation?hosting=cloud&tab=reviews"}
                                   target={"_blank"}
                                   className={"button primary"} onClick={() => postHogService.logEvent(AnalyticsEvents.ADMIN_REVIEW_BANNER_REVIEW_CLICKED)}>Write
                                    a review</a>
                                <a href={"https://help-seibertmedia.atlassian.net/servicedesk/customer/portal/10/group/34/create/78"} target={"_blank"}
                                   className={"button default"} onClick={() => postHogService.logEvent(AnalyticsEvents.ADMIN_REVIEW_BANNER_REWARD_CLICKED)}>Claim
                                    your reward</a>
                            </div>
                        </div>
                    </div>
                    <div className={"hideButton"}>
                        <IconButton icon={CrossIcon} label="Hide forever" onClick={onClickHideReviewBanner}/>
                    </div>
                </div>
            }
        </>
    );
}
